import { computed, observable, runInAction } from "mobx";
import { ViewModelBase, FieldType } from "@shoothill/core";
import { DailyDiaryModel, DailyDiaryModelDTO } from "./DailyDiaryModel";
import { ServerViewModel } from "../../../../Globals/ViewModels/ServerViewModel";
import { AppUrls } from "../../../../AppUrls";
import { viewModelModelLink } from "../../../../Utils/Utils";
import { FireExitViewModel } from "../Audits/EndOfWeek/FireExitViewModel";
import { DailyDiaryQuestionViewModel } from "./DailyDiaryQuestionViewModel";
import { formatDateTime } from "Utils/Format";
import { DailyDiaryQuestionModelDTO } from "./DailyDiaryQuestionModel";

export class DailyDiaryViewModel extends ViewModelBase<DailyDiaryModel> {
    public server: ServerViewModel = new ServerViewModel();
    public date: Date | null = null;
    public dailyDiaryQuestionViewModels = observable<DailyDiaryQuestionViewModel>([]);
    constructor(model = new DailyDiaryModel()) {
        super(model);
        this.setDecorators(DailyDiaryModel);
    }

    @computed
    public get submittedDateFormatted() {
        return this.model.submittedDate ? formatDateTime(this.model.submittedDate.toString()) : "";
    }

    public dailyDiaryLinkObserverDispose = viewModelModelLink(this.model.dailyDiaryQuestionModels, this.dailyDiaryQuestionViewModels, DailyDiaryQuestionViewModel);

    public getDailyDiary = async () => {
        return this.server.query<any>(
            () => this.Get<DailyDiaryModelDTO>(`${AppUrls.Server.Projects.Construction.DailyDiary.Load}?projectId=${this.model.projectId}&date=${this.date?.toISOString()}`),
            (result) => {
                runInAction(() => {
                    this.model.fromDto(result);
                });
            },
        );
    };

    public submit = async () => {
        let questions: DailyDiaryQuestionModelDTO[] = this.dailyDiaryQuestionViewModels.map((q) => {
            return q.model.toDto();
        });

        return this.server.query<any>(
            () =>
                this.Post<DailyDiaryModelDTO>(`${AppUrls.Server.Projects.Construction.DailyDiary.Submit}`, {
                    id: this.model.projectId,
                    date: this.date?.toISOString(),
                    dailyDiaryQuestions: questions,
                }),
            (result) => {
                runInAction(() => {
                    this.model.fromDto(result);
                });
            },
        );
    };

    /**
     * Custom model validation function. Validates child question models.
     * @returns True if model is valid, false if not.
     */
    public isMyModelValid = async (): Promise<boolean> => {
        let isValid = true;

        // JC: Changed forEach into for loop as the await seems to have issues with forEach.
        for (let i = 0; i < this.dailyDiaryQuestionViewModels.length; i++) {
            let item = this.dailyDiaryQuestionViewModels[i];

            // Validate each child item.
            if ((await item.isModelValid()) === false) {
                isValid = false;
            }
        }

        if ((await this.isModelValid()) === false) {
            isValid = false;
        }

        return isValid;
    };

    public async isFieldValid(fieldName: keyof FieldType<DailyDiaryModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
